import { AUTH_LOGIN, AUTH_CHECK, AUTH_LOGOUT, AUTH_ERROR, AUTH_GET_PERMISSIONS } from 'react-admin';
import { HOST, API } from '../configs/index'

export default (type, params) => {
    if (type === AUTH_LOGIN) {
        const { username, password } = params;
        const request = new Request(`${HOST}/auth/local`, {
            method: 'POST',
            body: JSON.stringify({ identifier: username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        })
        return fetch(request)
            .then(response => {
                // if (response.status < 200 || response.status >= 300) {
                //     throw new Error(response.statusText);
                // }
                return response.json();
            })
            .then(({ jwt, user, statusCode, error, message }) => {
                if ((statusCode < 200 || statusCode >= 300) || error) {
                    throw new Error(message || error);
                } else {
                    const { role: { type }, project, permission } = user
                    if ((type === 'admin' && Array.isArray(project) && project.length > 0)
                        || type === 'superadmin') {
                        localStorage.setItem('role', type);
                        if (permission)
                            localStorage.setItem('permission', JSON.stringify(permission));
                        localStorage.setItem('project', project ? JSON.stringify(project) : JSON.stringify([]));
                        localStorage.setItem('token', jwt);
                    } else {
                        throw new Error('Unauthorized');
                    }
                }
                // window.location = window.location.origin;
            });
    }
    if (type === AUTH_ERROR) {
        const status = params.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            localStorage.removeItem('project');
            localStorage.removeItem('permission');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('project');
        localStorage.removeItem('permission');
        return Promise.resolve();
    }
    if (type === AUTH_CHECK) {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject({ redirect: '/no-access' });
    }
    if (type === AUTH_GET_PERMISSIONS) {
        const role = localStorage.getItem('role');
        return role ? Promise.resolve(role) : Promise.reject();
    }
    return Promise.reject('Unkown method');
}


// WEBPACK FOOTER //
// ./src/services/authProvider.js